module.exports = __webpack_public_path__ + "img/local_dining.b723f14a.svg";